import { Box, Typography, Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import Reveal from '../components/Reveal';
import { tokens } from '../theme';

const AboutSection = () => {
  const { t } = useTranslation();
  const bagImage = `${process.env.REACT_APP_CLOUDFRONT_URL}/public/TokkiBunny.webp`;

  return (
    <Box
      id="about-section"
      sx={{
        py: { xs: 8, md: 14 },
        px: { xs: 2, md: 5 },
      }}
    >
      <Grid container spacing={{ xs: 5, md: 8 }} alignItems="center">
        <Grid size={{ xs: 12, md: 7 }}>
          <Reveal>
            <Typography variant="h2" component="h2" sx={{ textWrap: 'balance' }}>
              {(t as any)('about.title')}
            </Typography>
          </Reveal>

          <Reveal delay={70}>
            <Typography
              variant="body1"
              sx={{
                mt: 3,
                color: 'text.secondary',
                fontSize: { xs: '1.0625rem', md: '1.1875rem' },
                lineHeight: 1.7,
                // Comfortable measure. Long lines are the most common reason a
                // paragraph goes unread on a wide screen.
                maxWidth: '62ch',
              }}
            >
              {(t as any)('about.description')}
            </Typography>
          </Reveal>
        </Grid>

        <Grid size={{ xs: 12, md: 5 }}>
          <Reveal delay={140} distance={20}>
            <Box
              sx={{
                position: 'relative',
                aspectRatio: '4 / 5',
                // Was minHeight: 425 with an absolutely positioned child, which
                // reserved the wrong box on wide screens. An aspect ratio holds
                // the right space at every width and keeps CLS at zero.
                borderRadius: `${tokens.radius.lg}px`,
                overflow: 'hidden',
                boxShadow: tokens.shadow.md,
              }}
            >
              <Box
                component="img"
                src={bagImage}
                alt={(t as any)('alt.aboutBag')}
                loading="lazy"
                decoding="async"
                sx={{
                  position: 'absolute',
                  inset: 0,
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                  objectPosition: 'center',
                }}
              />
            </Box>
          </Reveal>
        </Grid>
      </Grid>
    </Box>
  );
}

export default AboutSection;
